import { cn } from '@/lib/utils'

export type MatchSide = 'home' | 'away'

const STRIPE: Record<MatchSide, string> = { home: 'bg-sea', away: 'bg-coral' }

/** Striscia di lato accanto al nome di una squadra o di un giocatore in partita: azzurra la casa, corallo la trasferta. */
export function SideMark({ side, className }: { side: MatchSide; className?: string }) {
  return <span aria-hidden="true" className={cn('h-4 w-1 shrink-0 rounded-full', STRIPE[side], className)} />
}
